/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { useQuery } from '@apollo/client/react';
import { Container, useTheme } from '@mui/material';
import { useAtom } from 'jotai';
import { isMobile } from 'react-device-detect';
import { useNavigate, useParams } from 'react-router';

import { EventForm } from '../../components/Event/Form/EventForm/EventForm';
import type { Gec_Events } from '../../gql/graphql';
import { GET_FILTERED_EVENTS } from '../../graphql/queries';
import useParseEvents from '../../hooks/useParseEvents/useParseEvents';
import { formModeAtom, selectedEventAtom } from '../../state/atoms/atoms';

export const Event = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const eventId = id ? Number.parseInt(id) : null;
  const { data } = useQuery(GET_FILTERED_EVENTS, {
    variables: { filters: { id: { _eq: eventId } } },
  });
  const event = useParseEvents(data?.gec_events as Gec_Events[]);
  const theme = useTheme();
  const [selectedEvent, setSelectedEvent] = useAtom(selectedEventAtom);
  const [, setFormMode] = useAtom(formModeAtom);

  useEffect(() => {
    if (event) {
      setFormMode('preview');
      setSelectedEvent(event[0]);
    }
  }, [event, setSelectedEvent]);

  useEffect(() => {
    if (!eventId) {
      void navigate('/');
    }
  }, [eventId, navigate]);

  const styles = {
    centerFormMobile: {
      width: '100%',
      padding: '1rem',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    centerFormOther: {
      width: '45%',
      padding: '1rem',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        minWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        height: '100%',
      }}
    >
      {isMobile ? (
        <Container sx={styles.centerFormMobile}>{selectedEvent && <EventForm />}</Container>
      ) : (
        <Container sx={styles.centerFormOther}>{selectedEvent && <EventForm />}</Container>
      )}
    </Container>
  );
};

export default Event;
